import { Resvg } from '@resvg/resvg-wasm'
import { initResvg } from './initResvg'

export const buildSvgOverlay = async (svgElements, { width, height }) => {
  await initResvg()

  if (!OffscreenCanvas || typeof OffscreenCanvas === 'undefined') {
    return
  }
  const svg = `<svg
        width="${width}px"
        height="${height}px"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg">
        ${svgElements}
      </svg>`

  const resvg = new Resvg(svg)

  const pngData = resvg.render()

  const pngBytes = pngData.asPng() // Uint8Array

  return offscreenCanvasFromArrayBuffer(pngBytes)
}

/**
 * Create an OffscreenCanvas from an ArrayBuffer containing PNG/JPEG
 * @param {ArrayBuffer} buffer
 * @returns {Promise<OffscreenCanvas>}
 */
async function offscreenCanvasFromArrayBuffer(buffer) {
  const blob = new Blob([buffer], { type: 'image/png' }) // or 'image/jpeg'

  const bitmap = await createImageBitmap(blob)

  const canvas = new OffscreenCanvas(bitmap.width, bitmap.height)
  const ctx = canvas.getContext('2d')

  ctx.drawImage(bitmap, 0, 0)

  return canvas
}
